import EventRequestForm from "../components/contactform/EventRequestForm";
import { FactList, SectionLabel } from "../components/site/Blocks";
import { CONTACT, LOCATION } from "../config/location";
import { EVENT_FACTS, EVENT_OFFERS } from "../config/content";

// TODO Inhalt Kunde: alle Texte der Seite; Platzhalter in config/content.js, Liefergebiet Catering

const Feiern = () => (
    <>
        <section className="relative h-[72vh] min-h-[520px] overflow-hidden bg-nacht">
            {/* TODO Inhalt Kunde: nach dem Shooting ein Foto einer Feier in der Mineralix-Arena */}
            <img
                src="/media/meze-tafel.jpeg"
                alt="Meze-Platten auf dem Tisch"
                className="absolute inset-0 h-full w-full object-cover object-[center_45%]"
            />
            <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(14,22,18,.82)_0%,rgba(14,22,18,.45)_55%,rgba(14,22,18,.1)_100%)]" />
            <div className="absolute inset-0 bg-[linear-gradient(0deg,rgba(14,22,18,.75)_0%,rgba(14,22,18,.35)_45%,rgba(14,22,18,0)_75%)]" />
            <div className="absolute left-6 right-6 bottom-10 desk:left-[var(--gutter)] desk:right-[var(--gutter)] desk:bottom-16 xwide:bottom-24 max-w-[760px] xwide:max-w-[1000px] text-creme">
                <div
                    className="mb-6 text-xs font-semibold uppercase tracking-[.26em] text-messing-hell hero-in"
                    style={{ animationDelay: ".2s" }}
                >
                    Veranstaltungen &amp; Catering
                </div>
                <h1 className="h1-page mb-6 !text-[clamp(40px,5.5vw,78px)] xwide:!text-[clamp(78px,4vw,104px)] !leading-[1.04] hero-in" style={{ animationDelay: ".35s" }}>
                    Feiern, Familienfeste, Firmenessen.
                </h1>
                <p className="m-0 max-w-[480px] text-lg xwide:text-xl leading-[1.6] text-creme/85 hero-in" style={{ animationDelay: ".5s" }}>
                    Bei uns im Restaurant und auf der Terrasse, oder als Catering bei Ihnen.
                </p>
                <a href="#anfrage" className="btn btn-light mt-8 hero-in" style={{ animationDelay: ".65s" }}>
                    Feier anfragen
                </a>
            </div>
        </section>

        <section className="sec sec-y grid-3">
            <SectionLabel>01 — Feiern bei uns</SectionLabel>
            <div>
                <h2 className="h2-sec reveal mb-5 h2-sec-sm">Ihr Fest in der <span className="whitespace-nowrap">{LOCATION.venue}.</span></h2>
                <p className="body-text reveal d1 mb-8 max-w-[440px] xwide:max-w-[520px]">
                    Geburtstage, Taufen, Hochzeiten, Vereins- und Firmenfeiern von 10 bis 200 Personen. Ab 20 Personen auch
                    samstagmittags. Menü oder Buffet stellen wir gemeinsam mit Ihnen zusammen.
                </p>
                <FactList rows={EVENT_FACTS} className="reveal d2 max-w-[440px] xwide:max-w-[520px]" />
            </div>
            <div className="grid grid-cols-2 items-start gap-4">
                <div className="mask">
                    <img src="/media/meze-tisch.jpeg" alt="Gedeckter Tisch mit Meze" loading="lazy" className="block aspect-[4/5] w-full object-cover" />
                </div>
                <div className="mask pt-12">
                    <img src="/media/grillplatte.jpeg" alt="Grillplatte" loading="lazy" className="block aspect-[4/5] w-full object-cover" />
                </div>
            </div>
        </section>

        <section className="sec sec-y grid-3 bg-leinen">
            <SectionLabel>02 — Catering</SectionLabel>
            <div className="reveal reveal-scale grid grid-cols-2 gap-4">
                <div className="mask">
                    <img src="/media/calamari.jpeg" alt="Calamari" loading="lazy" className="block aspect-square w-full object-cover" />
                </div>
                <div className="mask">
                    <img src="/media/buffet.jpeg" alt="Buffet" loading="lazy" className="block aspect-square w-full object-cover" />
                </div>
            </div>
            <div>
                <h2 className="h2-sec reveal mb-5 h2-sec-sm">Griechisch essen, wo Sie feiern.</h2>
                <p className="body-text reveal d1 mb-8 max-w-[440px]">
                    Meze-Platten, Grillfleisch, Salate und Desserts für Ihr Fest oder Ihre Firmenveranstaltung. Umfang,
                    Lieferung und Preise besprechen wir persönlich.
                </p>
                <a href="#anfrage" className="link-underline reveal d2 inline-block">
                    Catering anfragen
                </a>
            </div>
        </section>

        <section className="sec sec-y-md grid-2">
            <SectionLabel>03 — Beispiele</SectionLabel>
            <div>
                <h2 className="h2-sec reveal mb-4 h2-sec-sm">Zur Orientierung.</h2>
                <p className="body-text reveal d1 mt-0 mb-12 max-w-[560px]">
                    Jede Feier stellen wir individuell zusammen. Diese Beispiele helfen bei der Planung.
                </p>
                <div className="grid gap-10 desk:grid-cols-3 desk:gap-[clamp(24px,3vw,56px)]">
                    {EVENT_OFFERS.map((offer, index) => (
                        <div key={offer.title} className={`reveal d${index + 1} border-t border-forest pt-6`}>
                            <h3 className="m-0 mb-3 font-caslon text-[clamp(22px,1.8vw,30px)] font-normal">
                                {offer.title}
                            </h3>
                            <p className="body-text mt-0 mb-4">{offer.text}</p>
                            <div className="text-sm font-semibold text-messing-dunkel">{offer.price}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>

        <section id="anfrage" className="sec sec-y grid-3w scroll-mt-8 border-t border-forest/10">
            <SectionLabel>04 — Anfrage</SectionLabel>
            <div>
                <h2 className="h2-sec reveal mb-5 h2-sec-sm">Erzählen Sie uns, was Sie vorhaben.</h2>
                <p className="body-text reveal d1 m-0 max-w-[400px]">
                    Wir melden uns mit einem Vorschlag. Oder direkt:{" "}
                    <a href={CONTACT.phoneHref} className="underline">
                        {CONTACT.phone}
                    </a>{" "}
                    ·{" "}
                    <a href={`mailto:${CONTACT.email}`} className="underline">
                        {CONTACT.email}
                    </a>
                </p>
            </div>
            <EventRequestForm />
        </section>
    </>
);

export default Feiern;
